import styled from "styled-components"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useState } from "react"
import { getIslemLog } from "../../features/admin3/admin3Slice"
import Btn from "../../components/shared/button/Btn"
import Pagination from "../../components/shared/Pagination"
import PageTopTitle from "../../components/shared/PageTopTitle"
import InputText from "../../components/shared/input/new/InputText"
import InputDate from "../../components/shared/input/new/InputDate"
import IslemKayitlariTable from "../../components/shared/sistemIslemKayitlari/IslemKayitlariTable"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
      width: calc(100% - 60px);
      gap: 60px;
      margin: 30px;

      .top-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        gap: 20px;
        margin: 20px 0;
        margin-bottom: 20px;

      }
    }
}
`



const SistemIslemKayitlari = () => {

    const dispatch = useDispatch()

    //! queries
    const [currentPage, setCurrentPage] = useState(1)
    const [path, setPath] = useState("")
    const [ipAdres, setIpAdres] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [user, setUser] = useState("")
    const [itemsPerPage, setItemsPerPage] = useState(20)

    const {logList, logDataCount, isLoadingGetIslemLog} = useSelector(state => state.admin3)
    const totalPages = Math.ceil(logDataCount / (itemsPerPage < 1 ? 20 : itemsPerPage));
    
    useEffect(()=> {
        dispatch(getIslemLog({
          page: currentPage,
          path,
          ipAddress:ipAdres,
          filterStartDate: startDate,
          filterEndDate: endDate,
          user,
          itemsPerPage: itemsPerPage < 1 ? 20 : itemsPerPage
        }))
    },[currentPage, ipAdres, path, startDate, endDate, user, itemsPerPage])

    const handleReset = () => {
      setUser("")
      setCurrentPage(1)
      setPath("")
      setStartDate("")
      setEndDate("")
      setIpAdres("")
      setItemsPerPage(20)
    } 

    useEffect(() => {
      setCurrentPage(1)
    },[ipAdres, path, startDate, endDate, user, itemsPerPage])

    const handleItemsperPage = (e) => {

      const value = e?.target?.value.replace(/[^0-9]/g, '') 
      setCurrentPage(1)
      setItemsPerPage(value)
  }
  
  return (
    <Container>
        <div className="wrapper">
            <PageTopTitle title={"Sistem İşlem Kayıtları"} position='sticky'/>
            <div className="content">
              <div className="top-container">
                <InputText data={ipAdres} setData={(e) => setIpAdres(e.target.value)} labelText="IP Adresi" inputWidth={"220px"} name={"ipAdres"}/>
                <InputText data={user} setData={(e) => setUser(e.target.value)} labelText="Kullanıcı İsmi" inputWidth={"220px"} name={"user"}/>
                <InputText data={path} setData={(e) => setPath(e.target.value)} labelText="API Adresi" inputWidth={"220px"} name={"path"}/>
                <InputDate data={startDate} setData={(e) => setStartDate(e.target.value)} labelText="İlk Tarih" inputWidth={"220px"} name={"startDate"}/>
                <InputDate data={endDate} setData={(e) => setEndDate(e.target.value)} labelText="Son Tarih" inputWidth={"220px"} name={"endDate"}/>
                <InputText data={itemsPerPage} setData={(e) => handleItemsperPage(e)} labelText="Sayfa başı üye" inputWidth={"160px"}/>
                <Btn bgColor="#E85446" color="#fff" handleClick={handleReset} width={"220px"}>Sıfırla</Btn>
              </div>
              {
                isLoadingGetIslemLog ?
                <SmallSpinner size={"40px"} color={"#fff"}/>
                :
                <>
                  <IslemKayitlariTable list={logList}/>
                  <Pagination totalPages={totalPages} handleClick={setCurrentPage} currentPage={currentPage}/>
                </>
              }
            </div>
        </div>
    </Container>
  )
}

export default SistemIslemKayitlari